import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";

const navItems = [
  { to: "/", label: "首页" },
  { to: "/works", label: "作品库" },
  { to: "/about", label: "关于我们" },
  { to: "/faq", label: "常见问题" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-300 ${
        scrolled || open
          ? "bg-background-100/90 backdrop-blur-md border-b border-background-300/60"
          : "bg-transparent"
      }`}
    >
      <nav className="mx-auto flex h-16 md:h-[72px] max-w-7xl items-center justify-between px-4 md:px-6">
        <Link to="/" className="group flex items-center gap-2.5" aria-label="忍界同人志首页">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50 transition-transform group-hover:rotate-12">
            <i className="ri-fire-fill text-lg" />
          </span>
          <span className="font-heading text-lg font-bold tracking-wide text-foreground-950">
            忍界同人志
          </span>
        </Link>

        <div className="hidden items-center gap-1 md:flex">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) =>
                `rounded-md px-4 py-2 text-sm transition-colors whitespace-nowrap ${
                  isActive
                    ? "text-primary-400 bg-primary-500/10"
                    : "text-foreground-400 hover:text-foreground-950 hover:bg-background-200/60"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </div>

        <div className="hidden items-center gap-3 md:flex">
          <Link
            to="/works"
            className="flex items-center gap-2 rounded-md border border-background-300/70 px-4 py-2 text-sm text-foreground-300 transition-colors hover:border-primary-500/50 hover:text-primary-300 whitespace-nowrap"
          >
            <i className="ri-search-line text-sm" />
            搜同人
          </Link>
          <Link
            to="/works"
            className="rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 whitespace-nowrap"
          >
            开始追更
          </Link>
        </div>

        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          className="flex h-10 w-10 items-center justify-center rounded-md text-foreground-300 hover:text-foreground-950 md:hidden"
          aria-label="切换菜单"
        >
          <i className={`${open ? "ri-close-line" : "ri-menu-line"} text-2xl`} />
        </button>
      </nav>

      {open && (
        <div className="border-t border-background-300/60 bg-background-100/95 px-4 pb-5 pt-3 md:hidden">
          <div className="flex flex-col gap-1">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                className={({ isActive }) =>
                  `rounded-md px-3 py-2.5 text-sm ${
                    isActive
                      ? "text-primary-400 bg-primary-500/10"
                      : "text-foreground-300 hover:text-foreground-950 hover:bg-background-200/60"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
            <Link
              to="/works"
              className="mt-2 rounded-md bg-primary-500 px-3 py-2.5 text-center text-sm font-medium text-background-50"
            >
              开始追更
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}